<template>
  <div class="sub-program-container">
    <!-- Error Message -->
    <b-alert v-if="errorMessage" show variant="danger" class="text-center p-4">
      <h4 class="alert-heading mb-3">Akses Terbatas</h4>
      <p>Anda tidak mempunyai akses pada halaman ini</p>
      <hr />
      <a href="/logout" class="btn btn-outline-danger">
        <i class="uil uil-sign-out-alt me-2"></i>
        {{ $t("navbar.dropdown.marcus.list.logout") }}
      </a>
    </b-alert>

    <!-- Sub Programs Grid -->
    <div v-if="!isLoading" class="sub-program-grid">
      <b-row>
        <b-col
          v-for="program in accessibleSubProgrammes"
          :key="program.id"
          lg="4"
          md="6"
          sm="12"
          class="mb-4"
        >
          <div class="program-card h-100">
            <!-- Program Header -->
            <div class="program-header">
              <div class="program-icon">
                <i class="uil uil-books font-size-24"></i>
              </div>
              <h3 class="program-title">{{ program.name }}</h3>
            </div>

            <div v-if="params.programname === 'ipdn'" class="program-actions">
              <!-- Psikologi Button -->
              <router-link
                :to="
                  `/program/${params.programname}/${
                    params.id
                  }/${program.name.replace(/\//g, '-').toLowerCase()}/${
                    program.id
                  }/${program.name == 'PSIKOLOGI' ? 'psikologi' : 'skd'}`
                "
                class="action-button primary"
              >
                <i class="uil uil-brain me-2"></i>
                Detail Tryout
              </router-link>
            </div>

            <!-- Program Actions -->
            <div v-else class="program-actions">
              <!-- Psikologi Button -->
              <router-link
                :to="
                  `/program/${params.programname}/${
                    params.id
                  }/${program.name.replace(/\//g, '-').toLowerCase()}/${
                    program.id
                  }/psikologi`
                "
                class="action-button primary"
              >
                <i class="uil uil-brain me-2"></i>
                Psikologi
              </router-link>

              <!-- Akademik Button -->
              <router-link
                :to="
                  `/program/${params.programname}/${
                    params.id
                  }/${program.name.replace(/\//g, '-').toLowerCase()}/${
                    program.id
                  }/akademik`
                "
                class="action-button secondary"
              >
                <i class="uil uil-book-open me-2"></i>
                Akademik
              </router-link>
            </div>
          </div>
        </b-col>
      </b-row>

      <!-- Tampilkan pesan jika tidak ada sub program yang dapat diakses -->
      <div
        v-if="accessibleSubProgrammes.length === 0"
        class="no-programs-message text-center p-5"
      >
        <i class="uil uil-lock text-muted mb-3" style="font-size: 48px;"></i>
        <h3 class="text-muted">Tidak Ada Sub Program yang Dapat Diakses</h3>
        <p class="text-muted">
          Anda tidak memiliki akses ke sub program apapun pada program ini.
        </p>
      </div>
    </div>

    <!-- Loading State -->
    <div v-else class="loading-container">
      <loading-vue></loading-vue>
    </div>
  </div>
</template>

<script>
import appConfig from "@/app.config";
import axios from "axios";
import loadingVue from "@/components/loading.vue";
import { authHeader } from "../../../helpers/fakebackend/auth-header";

export default {
  components: {
    loadingVue,
  },
  page: {
    title: "Student",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "CBT - Siswa",
      items: [
        { text: "Dashboard", href: "/" },
        { text: "Student", active: true },
      ],
      setProgrammes: {},
      params: this.$route.params,
      isLoading: true,
      errorMessage: false,
      userData: null,
      userProgrammes: [],
    };
  },
  computed: {
    // Computed property untuk memfilter sub_programmes yang dapat diakses
    accessibleSubProgrammes() {
      if (
        !this.setProgrammes.sub_programmes ||
        this.setProgrammes.sub_programmes.length === 0
      ) {
        return [];
      }

      // Filter hanya sub program yang dapat diakses oleh user
      return this.setProgrammes.sub_programmes.filter((program) =>
        this.isProgrammeAccessible(program)
      );
    },
  },
  async created() {
    try {
      await this.getMe(); // Ambil data user terlebih dahulu
      await this.getDataProgrammes(); // Ambil data program
    } catch (error) {
      console.error("Error initializing data:", error);
      this.errorMessage = true;
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    async getMe() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/api/me`,
          { headers: authHeader() }
        );
        const userData = response.data.data;
        this.userData = userData;
        this.userProgrammes = userData.programmes || [];
      } catch (error) {
        console.error("Error fetching user data:", error);
        this.errorMessage = true;
      }
    },
    async getDataProgrammes() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/api/programmes/${this.$route.params.id}`
        );
        this.setProgrammes = response.data;
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.errorMessage = true;
        }
        console.error("Error fetching programme data:", error);
      }
    },
    isProgrammeAccessible(program) {
      // Cek apakah programme dapat diakses berdasarkan daftar programme pengguna
      if (!this.userProgrammes || this.userProgrammes.length === 0)
        return false;

      return this.userProgrammes.some(
        (userProgramme) => userProgramme.id === program.id
      );
    },
  },
  middleware: "authentication",
};
</script>

<style scoped>
.sub-program-container {
  padding: 1rem 0;
}

.program-card {
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  transition: all 0.3s ease;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
}

.program-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
}

.program-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.program-icon {
  background: #edf2ff;
  color: #a14dfd;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.program-icon i {
  font-size: 24px;
}

.program-title {
  color: #1f2937;
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.4;
}

.program-actions {
  margin-top: auto;
  display: grid;
  gap: 1rem;
}

.action-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  transition: all 0.2s ease;
  text-decoration: none;
}

.action-button i {
  font-size: 1.25rem;
}

.action-button.primary {
  background: #a14dfd;
  color: white;
}

.action-button.primary:hover {
  background: #a14dfd;
  transform: translateY(-1px);
}

.action-button.secondary {
  background: #f8fafc;
  color: #a14dfd;
  border: 2px solid #e2e8f0;
}

.action-button.secondary:hover {
  background: #f1f5f9;
  border-color: #a14dfd;
  transform: translateY(-1px);
}

.loading-container {
  height: 74vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.no-programs-message {
  background: white;
  border-radius: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  margin: 2rem auto;
  max-width: 600px;
}

/* Alert Styling */
.alert {
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

/* Font Sizes */
.font-size-24 {
  font-size: 24px;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .program-actions {
    grid-template-columns: 1fr;
  }

  .program-card {
    padding: 1.25rem;
  }
}
</style>
